import { library, dom } from '@fortawesome/fontawesome-svg-core';
import {
  faAddressCard,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowLeft,
  faArrowRight,
  faArrowDown,
  faBars,
  faCalendarAlt,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCopy,
  faDownload,
  faEdit,
  faExclamationTriangle,
  faEye,
  faFilePdf,
  faShippingTimed,
  faFileExport,
  faFolder,
  faFolderOpen,
  faGift,
  faGlobe,
  faInfoCircle,
  faMapMarkerAlt,
  faMapMarker,
  faMinus,
  faPhone,
  faPlus,
  faSave,
  faSearch,
  faSearchPlus,
  faShoppingCart,
  faCartPlus,
  faSlidersH,
  faSlidersV,
  faSort,
  faSortDown,
  faSortUp,
  faStopwatch,
  faSync,
  faTimes,
  faTimesCircle,
  faTrash,
  faUserCircle,
  faUndo,
  faRoute,
  faStore
} from '@fortawesome/pro-regular-svg-icons';

import {
  faFacebook,
  faYoutube,
  faLinkedin
} from '@fortawesome/free-brands-svg-icons';

export default function() {
  library.add(
    faAddressCard,
    faAngleDown,
    faAngleLeft,
    faAngleRight,
    faArrowDown,
    faAngleUp,
    faArrowLeft,
    faArrowRight,
    faBars,
    faCalendarAlt,
    faCheck,
    faCheckCircle,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCopy,
    faDownload,
    faEdit,
    faExclamationTriangle,
    faEye,
    faFilePdf,
    faShippingTimed,
    faFileExport,
    faFacebook,
    faFolder,
    faFolderOpen,
    faGift,
    faGlobe,
    faInfoCircle,
    faLinkedin,
    faMapMarkerAlt,
    faMapMarker,
    faMinus,
    faPhone,
    faPlus,
    faRoute,
    faSave,
    faSearch,
    faSearchPlus,
    faShoppingCart,
    faSort,
    faSortDown,
    faSortUp,
    faCartPlus,
    faSlidersH,
    faSlidersV,
    faStopwatch,
    faSync,
    faTimes,
    faTimesCircle,
    faTrash,
    faUserCircle,
    faUndo,
    faYoutube,
    faStore
  );

  dom.watch();
}
